import { proxy } from 'valtio';

/**
 * Creates the submenu state which is shared among SelectValueMenu and
 * its context menu actions.
 */
function createSubmenuState() {
  const state = proxy({
    isOpen: false,
  });

  function open() {
    state.isOpen = true;
  }

  function close() {
    state.isOpen = false;
  }

  function toggle() {
    state.isOpen = !state.isOpen;
  }

  return {
    state,
    open,
    toggle,
    close,
  };
}

export const submenu = createSubmenuState();
